export function roleTextConverter(role: string | undefined) {
  if (role === "" || undefined) return "";
  if (role === "manager") {
    return "Arbetsledare";
  }
  return "Servicetekniker";
}
